import { get } from 'lodash';
import { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { FormFeedback } from '../FormFeedback';
import { FormLabel } from '../FormLabel';

interface PasswordFieldProps {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

export const PasswordField = ({
  register,
  errors,
  name,
  label,
  required = false,
  placeholder,
  className = 'mb-3',
}: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const isInvalid = useMemo(() => !!get(errors, name), [errors, name]);

  return (
    <Form.Group className={className} controlId={name}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <div className="position-relative">
        <Form.Control
          type={showPassword ? 'text' : 'password'}
          required={required}
          placeholder={placeholder}
          {...register(name)}
          isInvalid={isInvalid}
          style={{ paddingRight: '2.5rem' }} // Reduced padding
        />
        <button
          type="button"
          className="btn position-absolute top-50 translate-middle-y border-0 bg-transparent p-0"
          style={{
            right: '0.75rem', // Closer to the right edge
            zIndex: 5,
            width: '1.5rem',
            height: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          tabIndex={-1}
        >
          {showPassword ? (
            <BsFillEyeSlashFill size={16} className={isInvalid ? 'text-danger' : 'text-muted'} />
          ) : (
            <BsFillEyeFill size={16} className={isInvalid ? 'text-danger' : 'text-muted'} />
          )}
        </button>
      </div>
      <FormFeedback clientError={get(errors, name)} />
    </Form.Group>
  );
};
